module.exports = __webpack_public_path__ + "img/thumbnail_PallasCat_f_erythristic.eeaafc7c.png";